<template>
  <div class="schoolMain" ref="schoolMain" id="schoolMain">
    <VoiceToText :customdeskId="customDeskId" :styleTemp="styleTemp"
      v-if="styleTemp.overAllStyle && styleTemp.overAllStyle.voiceInfo && styleTemp.overAllStyle.voiceInfo.isVoice" />
    <historyList v-if="styleTemp.overAllStyle.isOpenHistory" :list="historyLists" :activeId="activeTotalMenu"
      @delHistory="delHistory($event, 'historyLists')" @clikHistory="clikHistory($event, 'historyLists')"
      @clearAll="clearAll('historyLists')" @change-list="changeHistoryList($event, 'historyLists')" />
    <div class="schoolMain-container" :style="[getHeight]" v-for="doorList in historyLists" :key="doorList.id"
      v-show="doorList.id === activeTotalMenu" :id="doorList.id" ref="webdesign">
      <div class="webdesign-content-menu">
        <div class="webdesign-menu"
          :style="{ height: styleTemp.overAllStyle.isShowTopNavBar ? '' : '100vh', zIndex: model.style === 'wholecol' ? '98' : '' }"
          v-show="doorList.model.model === 'menu' && doorList.menuInfo.position === 'left'">
          <div v-if="doorList.model.style === 'wholecol'" class="webdesign-box"></div>
          <div class="webdesign-menu-list"
          :style="[{ position: doorList.model.style === 'wholecol' ? 'fixed' : 'relative' }, handleBgInfo(doorList.menuInfo.bgInfo)]">
            <leftNavMenu @handleMenuClick="handleMenuClick" :menuInfo="doorList.menuInfo" :menuLayoutList="doorList.menuLayoutList" :activeMenuItem="activeMenuItem" :activeMenu="activeMenu" :themeColor="styleTemp.overAllStyle.themeColor" :menuHeight="menuHeight" />
          </div>
        </div>
      </div>
      <div class="webdesign-content-container" :style="handleBgStyle" ref="webContentRef">
        <topMenuNav @topMenuClick="topMenuClick" :menuInfo="doorList.menuInfo" :menuList="doorList.menuLayoutList" :activeMenu="activeMenu" :themeColor="styleTemp.overAllStyle.themeColor" />
        <div class="nav-route" :style="[maxWidthComputed, { background: layout && layout.length === 0 ? '#fff' : '' }]"
          v-if="model.model === 'menu' && menuInfo.isOpen === 'open'">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item v-for="(nav, index) in navRoute" :key="index">
              <img class="nav-route-img" v-if="index === 0"
                src="https://bigdata.topeti.com/PCRepository/middleground/home/icon/frame.svg" />
              <span :style="{
                color: index + 1 === navRoute.length ? '#333333' : '',
              }">{{ nav.name }}</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <historyList v-if="doorList.model.model === 'menu' && doorList.menuInfo.isOpenMenuHistory"
          :list="doorList.historyLists" :activeId="activeMenuItem" @delHistory="delHistory($event, 'menuHistoryList')"
          @clikHistory="clikHistory($event, 'menuHistoryList')" @clearAll="clearAll('menuHistoryList')"
          @change-list="changeHistoryList($event, 'menuHistoryList')" />
        <div class="webdesign-content-container-c">
          <div class="nav-top-children" v-if="topNavChildList">
            <div class="nav-top-children-li"
              :style="{ backgroundColor: nav.id === activeMenuItem ? themeColorRgb : '' }"
              :class="nav.id === activeMenuItem ? 'nav-top-children-active' : ''" v-for="nav in topNavChildList"
              :key="nav.id" @click="handleTopLeftMenuClick(nav)">
              <div class="li-img">
                <icon-module v-if="isObject(nav.iconName)"
                  :config="activeMenuItem === column.id ? (nav.highIconName || nav.iconName) : nav.iconName" />
              </div>
              <div class="li-text">
                {{ nav.name }}
              </div>
            </div>
          </div>
          <template v-if="!isNewsPage">
            <!-- 拖拽区域 -->
            <div class="drageArea" ref="drageArea"
              :id="doorList.model.model === 'menu' ? `drageArea-${activeMenuItem}` : `drageArea-${activeTotalMenu}`"
              :style="[maxWidthComputed]"
              v-for="menuListItem in doorList.model.model === 'menu' ? doorList.historyLists : [{}]"
              :key="menuListItem.id" v-show="doorList.model.model === 'door' || menuListItem.id === activeMenuItem">
              <div class="no-data"
                v-if="getLayoutList(doorList, menuListItem) && getLayoutList(doorList, menuListItem).length === 0">
                <img v-if="!isLoading" src="https://bigdata.topeti.com/PCRepository/defaultSvg/door-defalut.png"
                  style="transform: translateX(-4px);" />
                <p>您还未开通本模块，请联系平台管理员进行开通！</p>
              </div>
              <!-- 55 -->
              <grid-layout v-else :layout="doorList.model.model === 'menu' ? menuListItem.layout : doorList.layout"
                :col-num="192" v-show="isAppenGridLayout" :row-height="10" :is-draggable="false" :is-resizable="false"
                :is-mirrored="false" :vertical-compact="false" :margin="[0, 0]" :use-css-transforms="true"
                :autoSize="true" :responsive="false" @layout-mounted="layoutMountedEvent" ref="gridLayout"
                @update:layout="(val) => handleLayoutUpdate(val, doorListIdx, menuListItemIdx)"
                :key="treeKey">
                <grid-item v-for="(item, i) in getLayoutList(doorList, menuListItem)" :x="item.x" :y="item.y"
                  :w="item.w" :h="item.h" :i="item.i" :key="item.i" :maxW="item.maxW" :maxH="item.maxH"
                  :minW="item.minW" :minH="item.minH" :class="handleOverSaveAreaStyle(item, 'class')">
                  <!-- :aspectRatio="item.aspectRatio" -->
                  <template #default="{ styleSync }">
                    <div class="grid-drage" :style="[handleOverSaveAreaStyle(item), getBgInfo(item), { borderRadius: handlerRadius }, item.type === 'indicatorsBread' ? { background: '#ffffff0a' } : '']">
                      <!-- {{ item.type }} -->

                      <!-- 办理概况 -->
                      <transaction v-if="item.type === 'transaction'" :info="item.info || {}" :themeColor="themeColor"
                        ref="transaction" :isClient="true" :style="{
                          borderRadius: handlerRadius
                        }" />
                      <!-- 明细栏 -->
                      <detail v-else-if="item.type === 'specification'" :info="item.info || {}"
                        :customDeskId="customDeskId" :themeColor="themeColor" @open-audit="openAudit" :style="{
                          borderRadius: handlerRadius
                        }" />
                      <!-- 文本组件 -->
                      <textCpn v-else-if="item.type === 'text'" :data="item" :isDoor="true" />
                      <!-- 滚动图 -->
                      <roll v-else-if="item.type === 'swiper'" :customDeskId="customDeskId" :dataInfo="item"
                        :compRadius="styleTemp.overAllStyle.compRadius" :themeColor="themeColor"
                        @open-dictionary="openDictionary" :style="{
                          borderRadius: handlerRadius
                        }" @changeNav="pageJump" @openAppInitiate="openAppInitiate" />
                      <!-- 分组栏目 -->
                      <boutique v-else-if="item.type === 'apply'" :customDeskId="customDeskId" :layoutWidth="layoutWidth"
                        :themeColor="themeColor" :dataInfo="item" :resizeData="resizeData" :roleList="roleList"
                        @open-dictionary="openDictionary" :style="{
                          borderRadius: handlerRadius
                        }" ref="boutiqueRef" @changeNav="pageJump" @openAppInitiate="openAppInitiate" />
                      <!-- 应用栏目 -->
                      <programa v-else-if="item.type === 'column'" :dataInfo="item" :customDeskId="customDeskId"
                        :themeColor="themeColor" :roleList="roleList" :style="{
                          borderRadius: handlerRadius
                        }" @changeNav="pageJump" @open-dictionary="openDictionary" />
                      <!-- 嵌入式栏目 -->
                      <implant v-else-if="item.type === 'implant'" :themeColor="themeColor" :dataInfo="item"
                        :customDeskId="customDeskId" :style="{
                          borderRadius: handlerRadius
                        }" @changeNav="pageJump" />
                      <mutual v-else-if="item.type === 'mutual'" :themeColor="themeColor" :dataInfo="item"
                        :customDeskId="customDeskId" :index="i" :organizationType="organizationType" @to-nav="pageJump" />
                      <space v-else-if="item.type === 'space'" :themeColor="themeColor" :dataInfo="item" :index="i" />
                      <!-- 仪表盘明细 -->
                      <inDetail @updateConfig="updateConfig" v-else-if="item.type === 'detailed'" :config="item"
                        :index="i" :customDeskId="customDeskId" :reportId="reportId" :reportArr="reportArr"
                        :spaceid="spaceid" :upaceid="upaceid" :themeColor="themeColor" :isDoor="true" />
                      <!-- 可视化 -->
                      <indicatorsBread v-else-if="item.type === 'indicatorsBread'" :styleSync="styleSync"
                        :tableData="item.tableData" :config="item" :index="i" :themeColor="themeColor"
                        :reportId="reportId" :reportArr="reportArr" :spaceid="spaceid" :upaceid="upaceid"
                        :theme="styleTemp.indicatorsColor && styleTemp.indicatorsColor.themeValue || {}" />
                    </div>
                  </template>
                </grid-item>
              </grid-layout>
            </div>
          </template>
          <div v-else style="flex: 1;width: 100%;">
            <NewsPage :styleTemp="styleTemp" :themeColor="themeColor" />
          </div>
        </div>
      </div>
    </div>
    <oaExamineAudit ref="AuditOpenChild" v-on:sourceAudit="sourceAudit"></oaExamineAudit>
    <icon-part></icon-part>
    <upOption ref="upOption"></upOption>
    <app-dialog
      :dialogInfo="{ dialogName: openInput.name, isVisible: openInput.isVisible, dialogWidth: '80%', dialogHeight: '85vh' }"
      :iId="openInput.iId" v-model:isDetail="openInput.isDetail" :appId="openInput.approvalId"
      v-model:addInputShow="openAddInputShow" :coverVal="openInput.search" :datatype="openInput.datatype"
      @close="doorUpCloe" />
    <div class="menu-top-btn-group" v-if="isAppenMenuBtn">
      <div class="menu-btn" @click="menuStepClick('prev')" v-if="topMenuList[0] && activeMenuItem !== topMenuList[0].id">上一步</div>
      <div class="menu-btn" @click="menuStepClick('next')" v-if="topMenuList[topMenuList.length - 1] && activeMenuItem !== topMenuList[topMenuList.length - 1].id"> 下一步</div>
    </div>
  </div>
</template>

<script>
import { getuserspaceroles, getuserroles } from '@/port/schoolInstrument/appConfig'
import { openapiUpdateisread, getcustomdesklist, getcustomdesk, getcustomdeskkey } from '@/port/schoolInstrument/appConfig'
import iconMixin from '@/components/common/icon/common.js'
import { debounce } from 'lodash'
import scenariosAndPortals from './schoolInstrument/mixins/scenariosAndPortals'
import parmsMixins from './schoolInstrument/mixins/parmsMixins'
import AppDialog from './schoolInstrument/mixins/AppDialog.vue'
import { getDetail, getIndicatorsBread } from './schoolInstrument/component/inDetailed/utils/getFormdata'
import NewsPage from './schoolInstrument/component/detailInfo/newsPage.vue'
import oaExamineAudit from '@/components/clientSide/oaExamineAudit.vue'
import { dealRolePermission } from '@/components/schoolInstrument/mixins/utils'
import { isConditionAppen } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { findTreeNodeEnhanced } from './schoolInstrument/mixins/utils'
import { GridLayout, GridItem } from 'grid-layout-plus'

export default {
  name: 'schoolMain',
  mixins: [scenariosAndPortals, iconMixin, parmsMixins],
  components: {
    GridLayout,
    GridItem,
    oaExamineAudit,
    AppDialog,
    NewsPage
  },
  provide() {
    return {
      isSpace: this.isSpace,
      isUpace: this.isUpace
    }
  },
  props: {
    customDeskId: {
      type: [Number, String],
      default: 0,
    },
    activeTopChildMenu: {
      type: Number,
      default: 0
    },
    activeTopMenu: {
      type: Number,
      default: 1
    },
    activeTotalMenu: {
      type: Number,
      default: 0
    },
    isLoading: {
      type: Boolean
    },
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      openInput: {
        isVisible: false,
        approvalId: '',
        search: {},
        iId: ''
      },
      openAddInputShow: false, // 发起单独使用的
      // 打开 audit 回来触发刷新
      auditId: '',
      dialogVisible: false,
      dialogWidth: '0',
      dialogHeight: {
        height: 0,
      },
      dialogLink: '',
      styleTemp: {
        overAllStyle: {}
      }, //所有样式数据
      themeColor: null,
      // 能够选择角色的列表
      roleList: [],
      loading: false,
      resizeData: 0,
      organizationType: [],
      saveLeft: 0,
      isSpace: this.$route.path === '/space/index',
      isUpace: this.$route.path === '/upace/index',
      reportId: '',
      reportArr: [],
      treeKey: 0,
      isNewsPage: Boolean(this.$route.query.id) && Boolean(this.$route.query.l)
    }
  },
  watch: {
    isLoading: {
      handler(val) {
        this.loading = val
      },
      immediate: true
    },
    loading(val) {
      this.$emit('update:isLoading', val)
    },
    customDeskId: {
      handler(val) {
        if (val != 0) {
          this.historyLists = []
          this.getConfig(val)
          this.getSaveLeft()
        }
      },
      deep: true, // 深度监听父组件传过来对象变化
      immediate: true,
    },
    'styleTemp.overAllStyle.themeColor': {
      handler(val) {
        this.$nextTick(() => {
          this.$refs.schoolMain.style.setProperty('--theme-color', val)
        })
      }
    }
  },
  created() { },
  mounted() {
    // 获取角色
    this.getRolesList()
    //- 判断是否有外链的accesstoken，有的话从缓存数据清除
    this.deleteExternal()
    //- 设置首页头部切换状态
    this.$store.commit('changeSelect', 0)
    window.onscroll = () => {
      if (document.documentElement.scrollTop > parseInt(window.getComputedStyle(this.$parent.$parent.$children[0].$el).height)) {
        if (this.$refs['webinf-menu']) {
          this.$refs['webinf-menu'].style.cssText = `position:fixed;width:240px;left:0;top:0;height:100%`
        }
      } else {
        if (this.$refs['webinf-menu']) {
          this.$refs['webinf-menu'].style.cssText = `position:initail;width:initail;left:initail;top:initail;height:100%`
        }
      }
    }
    window.onresize = debounce(this.getSaveLeft, 300)
    setTimeout(() => {
      this.getSaveLeft()
    }, 500);
  },
  beforeUnmount() {
    window.onscroll = null
    window.onresize = null
  },
  computed: {
    getHeight() {
      if (this.styleTemp.overAllStyle && this.styleTemp.overAllStyle.isOpenHistory) {
        return { height: 'calc(100% - 41px)' }
      } else {
        return { height: '100%' }
      }
    },
    layoutComp() {
      return this.layout.filter(item => item.pcShow) || []
    }
  },
  methods: {
  // 添加此方法处理布局更新
    handleLayoutUpdate(newLayout, doorIdx, itemIdx) {
      if (this.historyLists[doorIdx].model.model === 'menu') {
        // 菜单模式下的深层赋值
        this.historyLists[doorIdx].historyLists[itemIdx].layout = newLayout;
      } else {
        // 普通模式下的赋值
        this.historyLists[doorIdx].layout = newLayout;
      }
    },
    openAppInitiate({ approvalId, name, search, iId, id, datatype }) {
      this.openInput = {
        isVisible: true,
        approvalId: approvalId,
        name: name,
        search: search,
        iId: iId,
        isDetail: iId === 15 || iId === 16 /*|| iId === 13 || iId === 14*/,
        id: id || '',
        datatype: datatype
      }
      this.openAddInputShow = true
    },
    doorUpCloe() {
      this.openInput = {
        isVisible: false,
        approvalId: '',
        search: {},
        iId: ''
      }
    },
    handleOverSaveAreaStyle(item, type = 'style') {
      const roll = item.type === 'swiper' && item.info.rollConfig.layout === 2
      const bou = item.type === 'apply' && item.info.applyConfig.isOverSaveArea === 'y'
      const col = item.type === 'column' && item.info.isOverSaveArea === 'y'
      const space = item.type === 'space' && item.info.isOverSaveArea === 'y'
      if ((roll || bou || col || space) && this.saveArea) {
        if (type === 'style') {
          return {
            position: 'absolute',
            left: `-${this.saveLeft}px`,
            top: 0,
            width: '100vw'
          }
        } else {
          return 'pos-over-save'
        }
      }
    },
    async getRolesList() {
      const params = this.spaceid ? { spaceid: this.spaceid } : ''
      const fn = this.spaceid ? getuserspaceroles : getuserroles
      const { data, code, msg } = await fn(params)
      if (code === 0) {
        this.roleList = data.list
      } else {
        this.$message.error(msg)
      }
    },
    openAudit(val) {
      this.auditId = val.id
      if (val.appInfo && val.appInfo.inquire && val.appInfo.inquire === 4) {
        this.$refs.AuditOpenChild.AuditOpenList(val.item, 1)
      } else {
        this.$refs.AuditOpenChild.AuditOpenList(val.item)
      }
      this.informNotice(val.item, val.appInfo.inquire)
    },
    // 页面背景色/背景图片
    getOverAllColor(color) {
      document
        .getElementsByTagName('body')[0]
        .style.setProperty('--overall-color', color)
    },
    informNotice(val, type) {
      let obj = null
      if (type === 1 && val.status === 0) {
        obj = { userccappId: val.userccappId }
      } else if (val.isread === 0) {
        obj = { userApprovingId: val.userapprovingId }
      }
      if (obj)
        openapiUpdateisread(obj)
          .then((res) => {
            if (res.code === 0) this.refreshEl()
          })
          .catch((err) => {
            console.log(err)
          })
    },
    refreshEl() {
      const dom = this.$refs[this.auditId]
      if (dom) {
        dom[0].refreshList()
        this.$refs.transaction[0].getInfo()
      }
    },
    // 此方法作为通知更新存在
    sourceAudit(param) {
      if (param && param.isUp) this.refreshEl()
    },
    // - 获取配置数据
    async getConfig(roleId) {
      this.resetMenuData()
      this.loading = true
      let _data
      let deskkey = {}
      let api = getcustomdesklist
      // 默认门户
      if (roleId === '') return
      if (roleId === '-1') {
        _data = {
          type: 0,
          curpage: 1,
          pagesize: 1,
          sence: 2
        }
        this.spaceid ? _data.spaceid = this.spaceid : ''
        this.upaceid ? _data.upaceid = this.upaceid : ''
      } else {
        // 角色门户
        api = getcustomdesk
        _data = {
          type: 4,
          curpage: 1,
          pagesize: 1,
          customDeskId: roleId || '',
          sence: 2
        }
        this.spaceid ? _data.spaceid = this.spaceid : ''
        this.upaceid ? _data.upaceid = this.upaceid : ''
        deskkey = await getcustomdeskkey(_data)
        if (deskkey.code !== 0) {
          this.loading = false
          this.$message.error(deskkey.msg)
          return
        }
      }
      const keyone = deskkey.data
      api(_data, keyone).then(async (res) => {
        if (res.code === 0) {
          const info = res.data[0] ? res.data[0].content ? JSON.parse(res.data[0].content) : '' : res.data.content ? JSON.parse(res.data.content) : ''
          if (info) {
            await this.$store.dispatch('setAsyncUserData')
            if (info.customData && Array.isArray(info.customData)) {
              await this.setParams(info, roleId)
            }
            if (info.checkObj && info.checkObj.checked_apply !== undefined && info.checkObj.list === undefined) {
              // 最原始的老数据 直接返回
              this.loading = false
              return
            }
            this.themeColor = info.styleTemp.overAllStyle.themeColor
            // 画布需要列表
            this.checkObjList = info.checkObj.list
            // 明细走仪表盘逻辑使用
            try {
              if (info.reportId) {
                this.reportId = info.reportId
                this.reportArr = info.reportArr
                this.checkObjList.forEach(c => {
                  if (c.id === 1 || c.region === 'custom' || c.lists.length !== 0) {
                    if (c.lists.length !== 0) {
                      c.lists.forEach(f => {
                        const ly = f.layout
                        if (ly && ly.model.model === 'door') {
                          f.layout.door.layout.forEach(async d => {
                            if (d.type === 'detailed' || d.type === 'indicatorsBread') {
                              // TODO
                              const ind = info.reportArr.findIndex(ie => ie === d.i)
                              if (ind !== -1) {
                                if (d.type === 'detailed') {
                                  d = await getDetail(ind, d, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid })
                                } else if (d.type === 'indicatorsBread') {
                                  d = await getIndicatorsBread(ind, d, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid })
                                }
                                if (this.layout && this.layout.length > 0) {
                                  const inddd = this.layout.findIndex(it => it.i === d.i)
                                  if (inddd !== -1) this.layout[inddd] = JSON.parse(JSON.stringify(d))
                                }
                              }
                            }
                          })
                        } else if (ly && ly.model.model === 'menu') {
                          // 菜单模式
                          f.layout.menu.list.forEach(e => {
                            if (e.apply) {
                              e.apply.forEach(g => {
                                g.layout.forEach(async h => {
                                  if (h.type === 'detailed' || h.type === 'indicatorsBread') {
                                    // TODO
                                    const ind = info.reportArr.findIndex(ie => ie === h.i)
                                    if (ind !== -1) {
                                      if (h.type === 'detailed') {
                                        h = await getDetail(ind, h, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid })
                                      } else if (h.type === 'indicatorsBread') {
                                        h = await getIndicatorsBread(ind, h, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid })
                                      }
                                      if (this.layout && this.layout.length > 0) {
                                        const inddd = this.layout.findIndex(it => it.i === h.i)
                                        if (inddd !== -1) this.layout[inddd] = JSON.parse(JSON.stringify(h))
                                      }
                                    }
                                  }
                                })
                              })
                            } else {
                              e.layout.forEach(async f => {
                                if (f.type === 'detailed' || f.type === 'indicatorsBread') {
                                  // TODO
                                  const ind = info.reportArr.findIndex(ie => ie === f.i)
                                  if (ind !== -1) {
                                    if (f.type === 'detailed') {
                                      f = await getDetail(ind, f, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid })
                                    } else if (f.type === 'indicatorsBread') {
                                      f = await getIndicatorsBread(ind, f, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid })
                                    }
                                    if (this.layout && this.layout.length > 0) {
                                      const inddd = this.layout.findIndex(it => it.i === f.i)
                                      if (inddd !== -1) this.layout[inddd] = JSON.parse(JSON.stringify(f))
                                    }
                                  }
                                }
                              })
                            }
                          })
                        }
                      })
                    } else {
                      // 说明是画布
                      const layout = c.layout
                      if (layout && layout.model.model === 'door') {
                        c.layout.door.layout.forEach(async d => {
                          if (d.type === 'detailed' || d.type === 'indicatorsBread') {
                            // TODO
                            const ind = info.reportArr.findIndex(ie => ie === d.i)
                            if (ind !== -1) {
                              if (d.type === 'detailed') {
                                d = await getDetail(ind, d, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid })
                              } else if (d.type === 'indicatorsBread') {
                                d = await getIndicatorsBread(ind, d, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid })
                              }
                              if (this.layout && this.layout.length > 0) {
                                const inddd = this.layout.findIndex(it => it.i === d.i)
                                if (inddd !== -1) this.layout[inddd] = JSON.parse(JSON.stringify(d))
                              }
                            }
                          }
                        })
                      } else if (layout && layout.model.model === 'menu') {
                        // 菜单模式
                        c.layout.menu.list.forEach(e => {
                          if (e.apply) {
                            e.apply.forEach(g => {
                              g.layout.forEach(async h => {
                                if (h.type === 'detailed' || h.type === 'indicatorsBread') {
                                  // TODO
                                  const ind = info.reportArr.findIndex(ie => ie === h.i)
                                  if (ind !== -1) {
                                    if (h.type === 'detailed') {
                                      h = await getDetail(ind, h, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid })
                                    } else if (h.type === 'indicatorsBread') {
                                      h = await getIndicatorsBread(ind, h, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid })
                                    }
                                    if (this.layout && this.layout.length > 0) {
                                      const inddd = this.layout.findIndex(it => it.i === h.i)
                                      if (inddd !== -1) this.layout[inddd] = JSON.parse(JSON.stringify(h))
                                    }
                                  }
                                }
                              })
                            })
                          } else {
                            e.layout.forEach(async f => {
                              if (f.type === 'detailed' || f.type === 'indicatorsBread') {
                                // TODO
                                const ind = info.reportArr.findIndex(ie => ie === f.i)
                                if (ind !== -1) {
                                  if (f.type === 'detailed') {
                                    f = await getDetail(ind, f, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid })
                                  } else if (f.type === 'indicatorsBread') {
                                    f = await getIndicatorsBread(ind, f, { reportId: info.reportId, isSpace: this.isSpace, spaceid: this.spaceid })
                                  }
                                  if (this.layout && this.layout.length > 0) {
                                    const inddd = this.layout.findIndex(it => it.i === f.i)
                                    if (inddd !== -1) this.layout[inddd] = JSON.parse(JSON.stringify(f))
                                  }
                                }
                              }
                            })
                          }
                        })
                      }
                    }
                  }
                })
              }
            } catch (error) {
              console.log(error, 'ddddd');
            }
            // 判断导航栏（首页、应用中心、发现）是否有菜单设置隐藏状态，如果有菜单设置了隐藏状态，则默认显示下一个菜单的页面内容
            const curPath = this.$route.path
            const query = this.spaceid ? { spaceid: this.spaceid } : this.upaceid ? { upaceid: this.upaceid } : {}
            if ((this.activeTopMenu === 1 && this.isSpace ? curPath !== '/space/index' : curPath !== '/index') || (this.activeTopMenu === 1 && this.isUpace ? curPath !== '/upace/index' : curPath !== '/index')) {
              const path = this.isSpace ? '/space/index' : this.isUpace ? '/upace/index' : '/index'
              this.$router.push({ path, query })
            } else if (this.activeTopMenu === 2 && (curPath !== '/clientSide/oaExamine' || curPath !== '/space/oaExamine' || curPath !== '/upace/oaExamine')) {
              this.$emit('update:isLoading', false)
              const path = this.isSpace ? '/space/oaExamine' : this.isUpace ? '/upace/oaExamine' : '/clientSide/oaExamine'
              this.$router.push({ path, query }) //应用中心
            } else if (this.activeTopMenu === 3 && (curPath !== '/clientSide/workbench' || curPath !== '/space/workbench' || curPath !== '/upace/workbench')) {
              this.$emit('update:isLoading', false)
              const path = this.isSpace ? '/space/workbench' : this.isSpace ? '/upace/workbench' : '/clientSide/workbench'
              this.$router.push({ path, query }) //发现
            }
            let template;
            const userInfo = JSON.parse(localStorage.getItem("user"))
            if (info.model || info.template) {
              // 老数据
              if (info.model) {
                this.model = info.model
                if (info.model.model === 'menu') {
                  let menuList
                  if (userInfo && userInfo.isadmin < 3) {
                    // 管理员所有都能查看
                    menuList = info.menu.list
                  } else {
                    menuList = this.handleMenuPower(info)
                  }
                  this.menuLayoutList = menuList
                  this.menuInfo = info.menu.info
                  if (menuList.length !== 0) {
                    if (menuList[0].apply) {
                      const item = this.getAppenShow(menuList[0].apply)
                      this.handleMenuClick(menuList[0], item)
                    } else {
                      const item = this.getAppenShow(menuList)
                      this.handleMenuClick(item, item)
                    }
                  }
                } else {
                  template = info.door.template
                  this.handleApplyColumnPower(template)
                }
              } else {
                this.resetMenuData()
                template = JSON.parse(info.template)
                this.handleApplyColumnPower(template)
              }
            } else {
              // 新数据
              let user = localStorage.getItem('user')
              const customData = this.$store.state.doorCustomDataObj[_data.customDeskId]
              let list = info.checkObj.list.filter(item => {
                let isView = item.isShow
                if (isView && item.condition) {
                  isView = isConditionAppen(item.condition, {}, true, customData)
                }
                return isView
              })
              if (user && JSON.parse(user).isadmin >= 3) {
                list = await dealRolePermission({
                  val: list,
                  roleList: this.roleList,
                  children: 'lists'
                })
                list = list.filter(f => {
                  if (f.lists) {
                    f.lists = f.lists.filter(cf => !!cf.isPermissionAppen)
                  }
                  return !!f.isPermissionAppen
                })
              }
              let activeTopMenu = 1
              let activeTopChildMenu = 0
              let catchActiveMenu = localStorage.getItem('catchActiveMenu')
              let isCatch = false
              if (catchActiveMenu) {
                catchActiveMenu = JSON.parse(catchActiveMenu)
                const customDeskId = catchActiveMenu.customDeskId
                const topId = catchActiveMenu.topId
                if (customDeskId === roleId) {
                  const treeNode = findTreeNodeEnhanced({ lists: list, id: null }, topId, { idKey: 'id', childrenKey: 'lists', returnParent: true })
                  if (treeNode) {
                    const { node, parent } = treeNode
                    if (parent.id) {
                      this.$emit('change-cmenu', node.id)
                      this.$emit('change-menu', parent.id)
                      activeTopChildMenu = node.id
                      activeTopMenu = parent.id
                    } else {
                      this.$emit('change-cmenu', 0)
                      this.$emit('change-menu', node.id)
                      activeTopChildMenu = 0
                      activeTopMenu = node.id
                    }
                    this.$emit('change-totalmenu', node.id)
                    isCatch = true
                  }
                }
              }
              if (!isCatch) {
                const appen = list.find(f => (f.id === 1 || f.region === 'custom' || f.lists.length !== 0) && f.isShow)
                let isF = false
                if (appen && appen.id !== 1 && appen.lists.length === 0 && appen.region === 'custom' && appen.isShow) {
                  // 再去判断是lists是否为空数组
                  isF = true
                } else if (appen && appen.id !== 1 && appen.lists.length !== 0 && appen.isShow) {
                  const cur = appen.lists.find(f => f.region === 'custom' && appen.isShow)
                  if (cur) {
                    this.$emit('change-cmenu', cur.id)
                    this.$emit('change-totalmenu', cur.id)
                    activeTopChildMenu = cur.id
                    isF = true
                  }
                }
                if (isF) {
                  this.$emit('change-menu', appen.id)
                  activeTopMenu = appen.id
                } else {
                  this.$emit('change-menu', 1)
                  activeTopMenu = 1
                }
                const menuNav = localStorage.getItem('menuNav')
                if (menuNav && menuNav !== 'undefined') {
                  const value = JSON.parse(menuNav)
                  if (value.lists && value.lists.length !== 0 && !value.isChildren) {
                    // 如果是导航有子菜单 则导航父级菜单不能点击
                    return
                  }
                  if (value.parent_id === 0) {
                    // 处理点击了父级的按钮
                    activeTopMenu = value.id
                    activeTopChildMenu = 0
                    this.$emit('change-cmenu', 0)
                    this.$emit('change-menu', value.id)
                  } else {
                    activeTopChildMenu = value.id
                    activeTopMenu = value.parent_id
                    this.$emit('change-cmenu', value.id)
                    this.$emit('change-menu', value.parent_id)
                  }
                  localStorage.removeItem('menuNav')
                }
              }
              if (list.length !== 0) {
                await this.handleLoopCheckObjList(activeTopMenu, activeTopChildMenu)
              }
              if (info.styleTemp.topContentInfo && info.styleTemp.topContentInfo.list && info.styleTemp.topContentInfo.list.navbar) {
                this.$set(info.styleTemp.topContentInfo.list.navbar, 'list', list)
              }
            }
            this.styleTemp = info.styleTemp

            if (this.saveArea === undefined) {
              this.saveArea = info.styleTemp.overAllStyle.saveArea
            }
            this.$emit('on-success', this.styleTemp)
            this.loading = false
          } else {
            this.loading = false
          }
        } else {
          console.log('getcustomdesklist 接口出错')
          this.loading = false
          this.$message.error('配置错误，请联系管理员')
        }
      }).catch((err) => {
        console.log(err, 'err');
        this.loading = false
      })
    },
    //- 判断是否有外链的accesstoken，有的话从缓存数据清除
    deleteExternal() {
      var userData = localStorage.getItem('user')
      if (userData) {
        userData = JSON.parse(userData)
        if (userData.accesstoken_external) {
          delete userData.accesstoken_external
        }
        if (userData.apiurl_external) {
          delete userData.apiurl_external
        }
        if (userData.normalImgUrl) {
          delete userData.normalImgUrl
        }
        localStorage.setItem('user', JSON.stringify(userData))
      }
      //- 清除外链的userMsg
      let userMsg_external = localStorage.getItem('userMsg_external') //- 新增外链模式下面的userMsg
      if (userMsg_external) {
        localStorage.removeItem('userMsg_external')
      }
    },
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './schoolInstrument/mixins/style.scss';

:root {
  --overall-color: #f5f5f5;
}

::v-deep .el-scrollbar {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}

.schoolMain {
  flex: 1;
  display: flex;
  flex-direction: column;
  --theme-color: #4e86ff;
  $themeColor: var(--theme-color);
  &-container {
    display: flex;
    height: 100%;
    width: 100%;
  }
  .menu-top-btn-group {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    z-index: 999;
    bottom: 54px;

    .menu-btn {
      padding: 12px 35px;
      color: #fff;
      background-color: $themeColor;
      border-radius: 4px;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
      cursor: pointer;

      &:last-of-type {
        margin-left: 32px;
      }
    }
  }

  .webdesign-content-menu {
    .webdesign-menu {
      // max-height: 100vh;
      height: 100%;
      position: sticky;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      left: 0;
      top: 0;
      box-sizing: border-box;
      border-right: rgba(0, 0, 0, 0.09) solid 1px;
      z-index: 98;

      .webdesign-box {
        height: 100%;
        width: 240px;
      }

      &-list {
        flex: 1;
        height: 100%;
        position: relative;
        width: 240px;
        left: 0;
        top: 0;
        bottom: 0;

        .navbar-default {
          height: 100%;

          &-top-img {
            margin-top: 16px;
            height: auto;
            width: 100%;
            padding: 0 8px;
            box-sizing: border-box;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .navbar-default-mid {
            width: 100%;
            box-sizing: border-box;
            height: 1px;
            display: flex;
            justify-content: center;
            margin: 16px 0;

            div {
              width: 92%;
              box-sizing: border-box;
              height: 1px;
              background: #eeeeee;
            }
          }

          ::v-deep .el-menu {
            background-color: inherit;
          }
        }
      }
    }
  }

  .webdesign-content-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    justify-content: center;
    overflow-x: hidden;

    &-c {
      display: flex;
      align-items: center;
      justify-content: center;
      overflow-x: hidden;
      flex: 1;
      width: 100%;
      height: 100%;

      .nav-top-children {
        width: 180px;
        height: 100%;
        background-color: #fff;
        padding: 15px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;

        &-li {
          width: 100%;
          height: 40px;
          color: #666666;
          font-weight: 400;
          font-size: 14px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;

          .li-img {
            width: 25px;
            height: 25px;
          }

          .li-text {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-left: 10px;
          }
        }

        &-active {
          color: $themeColor;
          border-radius: 4px;
        }
      }
    }

    .top-menu {
      display: flex;
      box-sizing: border-box;
      border-bottom: solid 1px #ccc;
      padding: 6px 20px;
      background: #fff;
      width: 100%;

      &-item {
        padding: 5px 10px;
        background: rgba(75, 75, 75, 0.1);
        margin-right: 20px;
        font-size: 12px;
        color: #333;
        border-radius: 4px;
        box-sizing: border-box;
        cursor: pointer;
      }

      &-active {
        background: rgba(78, 166, 255, 0.1);
        color: $themeColor;
      }
    }

    ::v-deep .nav-route {
      height: 40px;
      box-sizing: border-box;
      width: 100%;

      &-img {
        max-width: 16px;
        max-height: 16px;
        margin-right: 4px;
      }

      .el-breadcrumb {
        height: 100%;
        line-height: 40px;
        margin-left: 20px;
        color: #333;

        .el-breadcrumb__item {
          display: flex;
          align-items: center;

          .el-breadcrumb__inner {
            display: flex;
            align-items: center;
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #9d9d9d;
          }
        }
      }
    }

    .drage-area {
      flex: 1;
    }
  }
}

$overall-color: var(--overall-color);

.drageArea {
  width: 100%;
  height: 100%;

  //内部框架滚动条
  // .vue-grid-layout {
  //   height: 93vh !important;
  //   width: 100%;
  //   overflow-y: scroll;
  // }
  .no-data {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    flex-direction: column;

    p {
      font-size: 16px;
      color: #9CA7B8;
      text-align: center;
      padding-top: 10px;
    }
  }

  .grid-drage {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center center;
    //box-shadow: 2px 2px 8px 0px rgba(186, 186, 186, 0.5);
    //border-radius: 4px;
    //border: 1px solid rgba(235, 235, 235, 1);
    position: relative;

    .toolArea {
      position: absolute;
      right: 6px;
      top: 7px;
      z-index: 22;

      .tool {
        display: inline-block;
        vertical-align: top;
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background-color: rgba(0, 0, 0, 0.5);
        cursor: pointer;
        border-radius: 3px;

        i {
          display: inline-block;
          font-size: 15px;
          color: white;
        }

        &:first-child {
          margin-right: 8px;
        }
      }
    }
  }
}

::v-deep .el-dialog__body {
  padding: 10px;
}

::v-deep .vue-grid-layout::-webkit-scrollbar {
  display: none;
}

::v-deep .el-loading-mask {
  position: fixed;
}

::v-deep .text-cpn {
  width: 100%;
  font-size: 16px;
}
</style>
